import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

const ShareableBlog = () => {
    const { id } = useParams(); 
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetch(`https://albiemer.onrender.com/api/blogs/${id}/`)
            .then(response => {
                if (!response.ok) throw new Error("Blog not found");
                return response.json();
            })
            .then(data => {
                setBlog(data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error:", error);
                setLoading(false);
            });
    }, [id]);

    if (loading) return <div className="blogcontainer" style={{ textAlign: "center", padding: "50px", color: "cyan" }}><p>Loading Post...</p></div>;
    if (!blog) return <div className="blogcontainer" style={{ textAlign: "center", padding: "50px" }}><p>Post not found.</p><Link to="/blogs" style={{ color: "cyan" }}>Back to list</Link></div>;

    return (
        <div className="blogcontainer" style={{ padding: "10px" }}>
            <div className="card" style={{ 
                maxWidth: "800px", 
                margin: "20px auto", 
                padding: "20px",
                textAlign: "left",
                backgroundColor: "#fff", // Puti ang background ng card para sa black text
                borderRadius: "10px"
            }}>
                {/* TITLE - Black para sa white card */}
                <h1 style={{ 
                    textAlign: "center", 
                    fontSize: "2.2rem", 
                    color: "#000", 
                    marginBottom: "20px",
                    fontWeight: "bold"
                }}>
                    {blog.title}
                </h1>
                
                <hr style={{ borderColor: "#ccc" }} />

                {/* IMAGE CONTAINER */}
                <div style={{ width: "100%", textAlign: "center", margin: "20px 0" }}>
                    <img src={blog.image} alt={blog.title} style={{ 
                        width: "100%", 
                        maxWidth: "600px", 
                        borderRadius: "8px",
                        border: "1px solid #ddd"
                    }} />
                </div>

                {/* DATE & AUTHOR - Darker cyan para mabasa sa white bg */}
                <div style={{ fontSize: "0.9rem", color: "#008b8b", marginBottom: "20px" }}>
                    [{blog.date}] - <b>{blog.author}</b>
                </div>

                {/* CONTENT - BLACK TEXT FIXED */}
                <p style={{ 
                    whiteSpace: "pre-wrap", 
                    lineHeight: "1.6", 
                    fontSize: "1.1rem", 
                    color: "#000000", // PURE BLACK
                    margin: "0",
                    fontWeight: "500"
                }}>
                    {blog.content}
                </p>

                {/* BUTTON */}
                <Link to="/blogs" style={{ textDecoration: "none" }}>
                    <button style={{
                        width: "100%", 
                        padding: "15px", 
                        background: "#000", // Black button
                        color: "cyan", // Cyan text sa button
                        border: "none", 
                        borderRadius: "5px",
                        fontWeight: "bold", 
                        marginTop: "30px", 
                        cursor: "pointer",
                        fontSize: "1rem"
                    }}>
                        VIEW ALL BLOGS
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default ShareableBlog;